// extracted by mini-css-extract-plugin
export default {"Box":"TableOfContentsPanel-module__Box--ehst0","NavList":"TableOfContentsPanel-module__NavList--LnyCZ"};